import { Radio } from 'antd';
import RadioConfigProvider from './RadioConfigProvider';

const GNERadio = ({
  checked,
  onChange,
  value,
  name,
  label,
  cssClass,
  wrapperCss,
}) => {
  return (
    <div
      className={`d-flex align-items-center ${wrapperCss ? wrapperCss : ''}`}>
      <RadioConfigProvider whiteTheme={wrapperCss === 'white-radio-btn'}>
        <Radio
          checked={checked}
          onChange={onChange}
          value={value}
          name={name}
          className='gne-radio'
        />
        {label && (
          <label className={`radio-label ${cssClass ? cssClass : ''}`}>
            {label}
          </label>
        )}
      </RadioConfigProvider>
    </div>
  );
};

export default GNERadio;
